module.exports = __webpack_public_path__ + "static/media/bonyan-logo-only.5a58f78a.png";